import React, { useState, useEffect } from "react";
import { Col, Row, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { FaUser, FaKey, FaLock } from 'react-icons/fa';  
import classnames from 'classnames';
import { useLocation } from "react-router-dom"; 
import CompanyUser from './CompanyUser';  
import CompanyLicenseKey from './CompanyLicenseKey';  
import CompanyPermissions from './CompanyPermissions';  
import BreadCrumb from "../../../components/common/BreadCrumb";

const CompanyDetail = () => {
  const [activeTab, setActiveTab] = useState("1");

  const location = useLocation();
  
  const [companyData, setCompanyData] = useState(location.state?.companyData || {});

  useEffect(() => {
    if (location.state?.companyData) {
      setCompanyData(location.state.companyData);
    }
  }, [location.state?.companyData]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <Col xxl={12}>
            <BreadCrumb title="Company Detail" pageTitle="Admin" />
          </Col>
        </Row>
        <Row>
          <Col md={2} style={{ height: 'calc(100vh - 100px)', borderRight: '1px solid #ddd' }}>
            <Nav pills className="flex-column mb-3">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                >
                  <FaUser className="me-2" /> 
                  User
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  <FaKey className="me-2" /> 
                  License Key
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: activeTab === "3" })} 
                  onClick={() => toggleTab("3")}
                >
                  <FaLock className="me-2" /> 
                  Subscriptions
                </NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col md={10}>
            <TabContent activeTab={activeTab}>
              {/* User Tab */}
              <TabPane tabId="1">
                <CompanyUser />
              </TabPane>

              {/* License Key Tab */}
              <TabPane tabId="2">
                <CompanyLicenseKey licenses={companyData.licenses} clientId={companyData.id}/> 
              </TabPane>

              {/* Permissions Tab */}
              <TabPane tabId="3">
                  <CompanyPermissions permissions={companyData.permissions} clientId={companyData.id} /> 
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default CompanyDetail;
